import useFetch from "../../../../hooks/useFetch"
import EstadosFacturaService from "../../../../../modules/EstadosFactura/application/EstadosFacturaService"
import {SelectInput, Spinner, Icon} from "asocomponents"

function SelectEstadoFactura({onChange, width, todos, valor}) {
  const estadosFacturaService = new EstadosFacturaService()
  const { isLoading, data, isFailed } = useFetch(
    estadosFacturaService,
    "getEstadosFactura",
  )

  if (isLoading) {
    return <Spinner color="red" size="10" />
  }

  if (isFailed) {
    return <Icon type="error"/>
  }

  return (
    <div>
      <SelectInput options={data} placeholder="Seleccionar" onChange={onChange} width={width} todos={todos && true} defaultValue={valor || "-2"}></SelectInput>
    </div>
  )
}

export default SelectEstadoFactura

